export enum FirstEntryType {
    Account = 'Account',
}
